module.exports = __webpack_public_path__ + "img/stock1.37a07a97.png";